import { setOverflowHidden } from './helpers';

export default function initNavigation() {
  let lastScrollTop = 0;
  const mainWrapper = document.getElementById('wrapper') as HTMLElement;
  const autohideElement = document.getElementById('header') as HTMLElement;

  function positionHeader() {
    const scrollTop = window.scrollY;
    if (scrollTop === 0) {
      autohideElement.classList.add('scrolled-top');
      autohideElement.classList.remove('scrolled-down', 'scrolled-up');

      mainWrapper.classList.add('scrolled-top');
      mainWrapper.classList.remove('scrolled-down', 'scrolled-up');
    } else if (scrollTop < lastScrollTop) {
      autohideElement.classList.remove('scrolled-top', 'scrolled-down');
      autohideElement.classList.add('scrolled-up');

      mainWrapper.classList.remove('scrolled-top', 'scrolled-down');
      mainWrapper.classList.add('scrolled-up');
    } else {
      autohideElement.classList.remove('scrolled-top', 'scrolled-up');
      autohideElement.classList.add('scrolled-down');

      mainWrapper.classList.remove('scrolled-top', 'scrolled-up');
      mainWrapper.classList.add('scrolled-down');
    }
    lastScrollTop = scrollTop;
  }

  if (autohideElement && mainWrapper) {
    document.addEventListener('DOMContentLoaded', () => {
      window.addEventListener('scroll', () => {
        positionHeader();
      });
      positionHeader();
    });
  }

  Alpine.data('navigation', () => ({
    hover: false,
    open: false,
    openDropdownKey: '',
    trapLangDropdown: false,
    trapSearchDropdown: false,
    sectionHover: 0,
    toggleMenuSection() {
      const button = this.$el;
      const { parentElement } = button;
      // close all other open dropdowns
      this.closeAllMenuSections(parentElement);
      // toggle current dropdown
      const { key } = button.dataset;
      if (key) {
        this.openDropdownKey = this.openDropdownKey === key ? '' : key;
        if (key === 'menu-lang' && window.innerWidth <= 1199) {
          this.trapLangDropdown = !this.trapLangDropdown;
        }
        if (key === 'menu-search' && window.innerWidth <= 1199) {
          this.trapSearchDropdown = !this.trapSearchDropdown;
        }

        if (parentElement) {
          parentElement.classList.toggle('drop-active');
          button.ariaExpanded = button.ariaExpanded === 'true' ? 'false' : 'true';
        }
      }
    },
    closeMenuSection() {
      const button = this.$el;
      const { key } = button.dataset;
      if (key === this.openDropdownKey) {
        this.openDropdownKey = '';
        if (key === 'menu-lang') {
          this.trapLangDropdown = false;
        }
        if (key === 'menu-search') {
          this.trapSearchDropdown = false;
        }
        button.parentElement?.classList.remove('drop-active');
        button.ariaExpanded = 'false';
        button.focus();
      }
    },
    closeAllMenuSections(currentItem?: Element | null) {
      const navItems = document.querySelectorAll('.group\\/nav-item.drop-active');
      Array.from(navItems).forEach((item) => {
        if (item !== currentItem) {
          this.openDropdownKey = '';
          this.trapLangDropdown = false;
          this.trapSearchDropdown = false;
          item.classList.remove('drop-active');
          const otherButtons = item.getElementsByTagName('button');
          Array.from(otherButtons).forEach((btn) => {
            // eslint-disable-next-line no-param-reassign
            btn.ariaExpanded = 'false';
          });
        }
      });
    },
    closeSearch() {
      if (this.openDropdownKey === 'menu-search') {
        this.closeAllMenuSections();
      }
    },
    isDialogOpen() {
      return this.open;
    },
    openDialog() {
      this.open = true;
      document.getElementById('header')?.classList.add('nav-active');
      document.getElementById('main-menu')?.classList.remove('invisible');
      setOverflowHidden();
    },
    closeDialog() {
      this.open = false;
      setOverflowHidden(false);
      document.getElementById('header')?.classList.remove('nav-active');
      document.getElementById('main-menu')?.classList.add('invisible');
      this.closeAllMenuSections();
      this.$nextTick(() => {
        setTimeout(() => {
          document.getElementById('main-menu-opener')?.focus();
        }, 20); // We have to wait for the DOM to be updated so that the searchInput is focusable
      });
    },
  }));
}
